export type Sessao = {
  id: string;
  email: string;
  nome: string;
  perfil_id: string;
  perfil_nome: string;
  categorias: string[];
  is_admin: boolean;
  expira: number;
  token: string;
};

const SESSAO_KEY = 'sessaoGestao';
const DURACAO_MS = 24 * 60 * 60 * 1000; // 24h

export function getSessao(): Sessao | null {
  try {
    const raw = localStorage.getItem(SESSAO_KEY);
    if (!raw) return null;
    const sessao: Sessao = JSON.parse(raw);
    if (Date.now() > sessao.expira) {
      localStorage.removeItem(SESSAO_KEY);
      return null;
    }
    return sessao;
  } catch {
    return null;
  }
}

export function clearSessao() {
  localStorage.removeItem(SESSAO_KEY);
}

export async function login(email: string, senha: string): Promise<Sessao> {
  const res = await fetch('/api/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim().toLowerCase(), senha }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error ?? 'Email ou senha incorretos');
  }

  const { data: { token, usuario } } = await res.json();

  const sessao: Sessao = {
    ...usuario,
    token,
    expira: Date.now() + DURACAO_MS,
  };

  localStorage.setItem(SESSAO_KEY, JSON.stringify(sessao));
  return sessao;
}
